export interface IUnauthorizedErrorResources {
    needAccount: string;
    login: string;
    needLogin: string;
    register: string;
}

export const UnauthorizedErrorResources: IUnauthorizedErrorResources = {
    login: "Zaloguj się",
    needLogin: "Opcja dostępna tylko dla zalogowanych użytkowników.",
    register: "Zarejestruj się",
    needAccount: "Nie masz konta?",
};
